<template>
  <div class="login">
    <div class="title">{{ $t('defineSecretQuestion') }}</div>

    <div class="info">
      {{ $t('defineSecretQuestionDescription') }}
    </div>

    <VeeForm v-slot="{ errors }" @submit="register">
      <Transition name="fade">
        <div v-if="error || Object.keys(errors).length > 0" class="error-container">
          <div class="error-icon">!</div>
          <div v-if="error" class="error-text">{{ error }}</div>
          <div v-else-if="errors['answer']" class="error-text">{{ $t('errorMessage.secretQuestionInvalid') }}</div>
          <div v-else-if="errors['answerConfirmation']" class="error-text">{{ $t('errorMessage.secretQuestionNotIdentical') }}</div>
        </div>
      </Transition>

      <div class="input-container">
        <div class="label-container">
          <div class="label">{{ $t('secretQuestion') }}</div>
        </div>
        <div class="secret-question" @click="secretQuestionsOpen = !secretQuestionsOpen">
          {{ secretQuestions && secretQuestions.length > questionId && secretQuestions[questionId] ? secretQuestions[questionId].value : '' }}
        </div>
        <div v-if="secretQuestionsOpen" class="secret-question-container">
          <div v-for="(secretQuestion, index) in secretQuestions" :key="index" class="secret-question-item" @click="selectSecretQuestion(index)">
            {{ secretQuestion.value }}
          </div>
        </div>
      </div>

      <div class="input-container">
        <div class="label-container">
          <div class="label">{{ $t('answer') }}</div>
        </div>

        <Field name="answer" rules="required|min:6" type="text" :placeholder="$t('answer')" />
      </div>

      <div class="input-container">
        <div class="label-container">
          <div class="label">{{ $t('answerConfirmation') }}</div>
        </div>

        <Field name="answerConfirmation" rules="confirmed:@answer" type="text" :placeholder="$t('answerConfirmation')" />
      </div>

      <button class="study-button main" :class="{ loading: loading }">
        {{ loading ? $t('loading') : $t('validate') }}
      </button>
    </VeeForm>
  </div>
</template>

<script>
import { Field, Form as VeeForm } from 'vee-validate';

import { mapGetters } from 'vuex';

export default {
  components: {
    VeeForm,
    Field,
  },

  data() {
    return {
      error: null,
      loading: false,
      questionId: 0,
      secretQuestionsOpen: false,
    };
  },

  computed: {
    ...mapGetters({
      registerInfo: 'registerInfo',
      secretQuestions: 'secretQuestions',
      userLanguage: 'userLanguage',
    }),
  },

  watch: {
    userLanguage() {
      this.$store.dispatch('getSecretQuestions');
    },
  },

  mounted() {
    this.$store.dispatch('getSecretQuestions');
    if (!(this.registerInfo && this.registerInfo.password)) {
      this.$router.push({
        name: 'userRegister',
        params: { emailKey: this.$route.params.emailKey },
        query: { studyId: this.$route.query.studyId },
      });
    }
  },

  methods: {
    register(values) {
      if (this.loading) return;
      this.loading = false;

      if (!(this.secretQuestions && this.secretQuestions.length > this.questionId && this.secretQuestions[this.questionId])) {
        this.error = this.$t('errorMessage.fillSecretQuestion');
        return;
      }

      this.loading = true;
      this.error = null;

      const studyId = this.$route.query.studyId;
      const userInfo = {
        secret_question: this.secretQuestions[this.questionId].value,
        secret_answer: values.answer,
      };

      this.$store
        .dispatch('clientRegister', { emailKey: this.$route.params.emailKey, studyId, userInfo })
        .then(() => {
          this.loading = false;

          this.$store
            .dispatch('updateUserInfo')
            .then(() => {
              if (studyId) {
                this.$router.push({ name: 'synthesis', params: { studyId: studyId } });
              } else {
                this.$router.push({ name: 'studyList' });
              }
            })
            .catch(() => {
              this.loading = false;
              this.error = 'Error';
            });
        })
        .catch(e => {
          this.loading = false;
          switch (e.code) {
            default:
              this.error = e.error;
              break;
          }
        });
    },

    selectSecretQuestion(questionId) {
      this.questionId = questionId;
      this.secretQuestionsOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/register.scss';
</style>
